import { render, staticRenderFns } from "./LocalisedBFormDatepicker.vue?vue&type=template&id=415bc9a9&"
import script from "./LocalisedBFormDatepicker.vue?vue&type=script&lang=ts&"
export * from "./LocalisedBFormDatepicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports